<template>
    <div v-if="material != null">
    <div class="row mb-1 mx-0">
        <h2 class="mr-auto">Material Bearbeiten</h2>
    </div>
    <form class="px-3">
        <div class="form-group row my-2">
            <label class="control-label col-4">EAN</label>
            <input type="text" style="text-align: right;" class="form-control form-control-sm col-8" :value="material.ean" readonly>
        </div>

        <div class="form-group row my-2" v-if="(material.eans !== undefined) && (material.eans.length != 0)">
            <label class="control-label col-4">Zusatz EAN<span v-if="material.eans.length > 1">s</span></label>
            <div class="col-8 pl-0">
                <p v-for="additionalEan in material.eans" class="my-0" v-bind:key="additionalEan">{{additionalEan.ean}} ({{additionalEan.origin}})</p>
            </div>
        </div>

        <div class="form-group row my-2">
            <label class="control-label col-4">Produktname</label>
            <input type="text" style="text-align: right;" class="form-control form-control-sm col-8" :value="product.name" readonly>
        </div>

        <div class="form-group row my-2">
            <label class="control-label col-4">Kategorie</label>
            <input type="text" style="text-align: right;" class="form-control form-control-sm col-8" :value="categoryMap[product.category+1]" readonly>
        </div>

        <div class="form-group row my-2">
            <label class="control-label col-4">UPC</label>
            <input type="text" style="text-align: right;" class="form-control form-control-sm col-8" :value="material.upc" readonly>
        </div>

        <div class="form-group row my-2">
            <label class="control-label col-4">ASIN</label>
            <input type="text" style="text-align: right;" class="form-control form-control-sm col-8" :value="product.asin" readonly>
        </div>

        <div v-if="isMaterialUndeliverable" class="form-group row my-2">
            <b class="text-danger offset-4 col-8 p-0">Lieferverzögerung</b>
        </div>
        <div class="form-group row my-2">
            <label class="control-label col-4"></label>
            <b-button class="col-8 my-auto" @click="createRequestJob()" :disabled="requestJob != null"  size="sm">{{(requestJob == null) ? 'Metadaten neu anfordern' : 'Anfrage läuft' }}</b-button>
        </div>
    </form>
    <modal-error-component v-model="modalError"></modal-error-component>
    </div>
</template>
<script>
    export default {
        props: [ 'passedMaterial', 'passedProduct' ],
        data() {
            return {
                    material: this.passedMaterial,
                    product: this.passedProduct,
                    requestJob: null,
                    isMaterialUndeliverable: this.passedMaterial.isUndeliverable,
                    categoryMap: [
                        'FORBIDDEN',
                        'Unknown',
                        'Music',
                        'Movie',
                        'Book',
                        'Toy',
                        'Game',
                        'Other',
                        'Kleidung',
                        'Beauty',
                        'Auto',
                        'Elektronik',
                        'Schmuck',
                        'Küche & Haus',
                        'Office',
                        'Haustierbedarf'
                    ],
                    modalError: {
                        show: false,
                        message: 'Der Speichervorgang konnte aufgrund eines Fehlers nicht durchgeführt werden.',
                        error: '',
                        title: ''
                    },
                debouncedSave: _.debounce( () => { this.save() }, 250, {})
            }
        },
        methods:
        {
            createRequestJob()
            {
                let requestJob = {
                    identifier: this.material.asin,
                    identifierType: 'asin',
                    type: 'update',
                    state: 'created',
                    doneAt: null,
                    productId: this.passedProduct.id
                };
                // console.log(requestJob);
                axios.post('/mds/request_job', requestJob).then( response => {
                    this.requestJob = response.data;
                }).catch( error => {
                    console.error(error);
                    alert("Netzwerkfehler");
                });
            },
            save()
            {
                axios.post('/material/save', this.material)
                .then( response => {
                    this.material = response.data;
                    if(this.material === undefined)
                    {
                        this.modalError.error = "Error: this.material is undefined.";
                    }
                    //updating lieferverzoegerung is not strictly necessary
                    axios.get('/material/' + this.material.id + '/undeliverable')
                    .then( response => this.isMaterialUndeliverable = response.data )
                    .catch( error => { alert("Netzwerkfehler. Materialdaten konnten nicht gespeichert werden."); console.log(error) });
                })
                .catch( error => {
                    console.log(error);
                    this.modalError.error = error.toString();
                    this.modalError.show = true;
                });
            },
        },
        created() 
        {
            let payload = {
                identifier: this.product.asin,
                identifierType: 'asin'
            };

            // get request_job status for product
            axios.post('/mds/request_job/open/by_identifier', payload).then( response => {
                if(response.data.length == 1) {
                    this.requestJob = response.data;
                }else if( response.data.length > 1) {
                    alert("Achtung: zu diesem Artikel gibt es mehrere Request Jobs. Bitte Umgehend Devs melden.");
                }else{
                    this.requestJob = null;
                }
            }).catch( error => {
                alert("Netzwerkfehler");
                console.log('get open requestJobs failed: ');
                console.log(error);
            });

        }
    }
</script>
